import React from 'react';

import ContentWrapper from '../ContentWrapper';
import Icon from '../Icon';
import SectionContainer from '../SectionContainer';
import AccessibleSlider from '../AccessibleSlider';

const SLIDER_SETTINGS = {
  dots: true,
  arrows: false,
  autoplaySpeed: 5000,
  adaptiveHeight: false,
  autoplay: true,
};

const getQuotes = (data) =>
  data.quotes.map((quote) => (
    <div
      key={quote.id}
      className={`quote-section-content ${
        data.backgroundColor ? data.backgroundColor : 'blue'
      }`}
    >
      <div key={quote.id}>
        <Icon icon="quote-right" size="lg" className="icon-color" />
        <p>{quote.quote.quote}</p>
        <h3>{quote.source}</h3>
        {quote.link ? (
          <a href={quote.link} target="_blank" rel="noreferrer">
            {quote.linkText ? quote.linkText : 'Read the entire review'}
          </a>
        ) : null}
      </div>
    </div>
  ));

export default function QuoteSection({ data }) {
  return (
    <SectionContainer
      className="quote-section"
      backgroundColor={data.backgroundColor || 'blue'}
    >
      <ContentWrapper>
        {data.quotes.length > 1 ? (
          <AccessibleSlider settings={SLIDER_SETTINGS}>
            {getQuotes(data)}
          </AccessibleSlider>
        ) : (
          getQuotes(data)
        )}
      </ContentWrapper>
    </SectionContainer>
  );
}
